<template>
    <section class="bg-white">
        <div class="container">

            <div :class="{'justify-between' : !screenSize.xs, 'justify-center' : screenSize.xs}" class="row items-end q-mb-lg">

                <a href="https://www.uponor.com" target="_blank"><img :src="require('@/assets/img/logos/oem/uponor.jpg')" class="float-right img-oem-logo" title="Uponor" /></a>
                <img :src="loopCAD.logo" :title="loopCAD.name" class="img-logo q-ml-lg q-mt-md" />
            </div>

            <div :class="{'text-center' : screenSize.xs}">
                <div class="text-title">LoopCAD Uponor Editions</div>
                <p>
                    Uponor provides two separate editions of LoopCAD - one for US customers and one for Canadian customers. Select the desired edition below to be directed to the appropriate download page.
                </p>

                <p>
                    The LoopCAD Uponor Editions include the "Radiant Express Design Mode", which is the free replacement for the previous Uponor ADS software. Additionally, the full drawing design features will be available to you in trial mode, giving you 30-days to evaluate the drawing features for free.
                </p>
            </div>
            <div class="row q-py-md q-col-gutter-md justify-center">
                <div class="col-xs-12 col-sm-auto">
                    <q-btn color="primary" to="/download/loopcad/upus" class="q-py-xs full-width">
                        <img class="on-left" style="max-height: 24px" :src="require('@/assets/img/flags/usa.png')" />
                        Click here for US Edition
                    </q-btn>
                </div>
                <div class="col-xs-12 col-sm-auto">
                    <q-btn color="primary" to="/download/loopcad/upca" class="q-py-xs full-width">
                        <img class="on-left" style="max-height: 24px" :src="require('@/assets/img/flags/canada.png')" />
                        Click here for Canadian Edition
                    </q-btn>
                </div>
            </div>
        </div>
    </section>
</template>
<script>

    import { productLines } from '@/plugins/productLines'
    export default {
        name: 'uponor-landing',
        props: {
        },
        data() {
            return {
                loopCAD: productLines.LoopCAD,
            }
        },
        methods: {

        },
        computed: {
            screenSize() {
                return this.$q.screen
            },
        },
        created() {

        }

    }
</script>
<style lang="scss" scoped>
    @import "../../styles/quasar.variables.scss";

    @media (max-width: $breakpoint-sm-max) {
        .img-logo {
            max-height: 60px;
        }

        .img-oem-logo {
            max-height: 85px !important;
        }
    }

    .img-oem-logo {
        max-width: 275px;
        max-height: 100%;
        height: unset;
    }
</style>
